export const ITEMS_CURRENTIMPORTID = 'ITEMS:CURRENT:IMPORT:ID';
export const ITEMS_FILESTOPPOLLING = 'ITEMS:FILE:STOP:POLLING';
export const ITEMS_FILESTATUS = 'ITEMS:FILE:STATUS';
export const ITEMS_USERLEFTSCREEN = 'ITEMS:USER:LEFT:SCREEN';
export const ITEMS_FILEREVIEWEDTOASTERSHOWED = 'ITEMS:FILE:REVIEWED:TOASTER:SHOWED';
export const ITEMS_CURRENTSTATUS = 'ITEMS:FILE:CURRENT:STATUS';
export const USER_ID = 'USER:ID';
export const SESSION_ORG_ID = 'USER:SESSIONORGID';
export const AUTH_DATA = 'authorizationData';
export const MSAL_TOKEN_ID = 'msal.idtoken';
export const ORGS_ONE_ORG_ONLY = 'ORGS:ONE:ORG:ONLY';
export const USER_MENU_FAVORITES = 'USER:MENU:FAVORITES';
export const USER_DB_PREFERENCES = 'USER:PREFERENCES';
export const VIEW_BAR_OPTIONS_PREV_VALUES = 'VB:OPTIONS';
export const AFTER_LOGIN_REDIRECT = 'USER:REDIRECT';
export const GRID_OPTIONS = 'GRID:OPTIONS';
